import React, { useState, forwardRef } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Slide,
  Typography,
  Button,
  Box,
  TextField,
} from '@mui/material';
import Slider from '@mui/material/Slider';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function PriceFilter({ open, onClose, onPriceRange }) {
  const [priceRange, setPriceRange] = useState([0, 200]);
  const [inputValues, setInputValues] = useState(['0', '200']);

  const handleSliderChange = (event, newValue) => {
    setPriceRange(newValue);
    setInputValues(newValue.map(String));
  };


  const handleInputChange = (index, value) => {
    const updatedInputs = [...inputValues];
    updatedInputs[index] = value;
    setInputValues(updatedInputs);

    // Only update priceRange if value is a valid number and not empty
    if (value === '') return;

    let numericValue = parseInt(value, 10);
    if (isNaN(numericValue)) return;

    let newRange = [...priceRange];
    if (index === 0) {
      numericValue = Math.min(numericValue, priceRange[1]);
      numericValue = Math.max(0, numericValue);
      newRange[0] = numericValue;
    } else {
      numericValue = Math.max(numericValue, priceRange[0]);
      numericValue = Math.min(200, numericValue);
      newRange[1] = numericValue;
    }
    setPriceRange(newRange);
  };

  const handleReset = () => {
    setPriceRange([0, 200]);
    setInputValues(['0', '200']);
  };

  const handleDone = () => {
    onPriceRange(priceRange); // Pass the selected range to the parent
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      slotProps={{ transition: Transition,
        paper: {
            sx: { borderRadius: '16px 16px 16px 16px', position: 'absolute', bottom: 0, width: '90%' },
        },
     }}
    >
      <DialogTitle>
        <Typography  sx={{ fontWeight: 'bold' }}>
          Price
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box sx={{ px: 4, py: 1, mt: 2 }}>
          {/* Slider */}
          <Slider
            value={priceRange}
            onChange={handleSliderChange}
            valueLabelDisplay="auto"
            min={0}
            max={200}
            sx={{ color: 'black' }}
          />
          {/* Price Inputs */}
          <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
            <TextField
              type="number"
              value={inputValues[0]}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, '');
                handleInputChange(0, value);
              }}
              inputMode="numeric"
              size="small"
              sx={{ width: '45%' }}
            />
            <Typography sx={{ mx: 1, alignSelf: 'center' }}>-</Typography>
            <TextField
              type="number"
              value={inputValues[1]}
              onChange={(e) => {
                const value = e.target.value.replace(/[^0-9]/g, '');
                handleInputChange(1, value);
              }}
              inputMode="numeric"
              size="small"
              sx={{ width: '45%' }}
            />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleReset} sx={{ flex: 1, color: 'black' }}>
          Reset
        </Button>
        <Button onClick={handleDone} variant="contained" sx={{ flex: 1, backgroundColor: 'black', color: 'white' }}>
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
}